import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isLoggedIn: false,
  listChurchNewEvents: {
    eventDetailid: "",
    eventName: "",
    eventFromDate: "",
    eventLocation: "",
    eventCode: "",
    eventCategoryId: "",
    eventCategoryName: ""
  },
  userInfo: {
    name: "",
    emailId: "",
  },
  canSubmitNewOrder: false,
  userFamilyProfileID:""
}

export const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    setGoogleAuthenticationLogin: (state, action) => {
      state.isLoggedIn = action.payload.isLoggedIn;
      state.userInfo = action.payload.userInfo;
      state.canSubmitNewOrder = action.payload.canSubmitNewOrder;
      state.userFamilyProfileID = action.payload.userFamilyProfileID
    },
    setGoogleAuthenticationLogout: (state) => {
      state.isLoggedIn = initialState.isLoggedIn;
      state.userInfo = initialState.userInfo;
      state.canSubmitNewOrder = initialState.canSubmitNewOrder;
    }
  },
})

// Action creators are generated for each case reducer function
export const { setGoogleAuthenticationLogin, setGoogleAuthenticationLogout } = authenticationSlice.actions;

export default authenticationSlice.reducer;